"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineUploadPermission = defineUploadPermission;
function defineUploadPermission(name, grantType, createGrant, signed) {
    return { name, grantType, createGrant, signed };
}
